import { render, staticRenderFns } from "./UploadCollateralModal.vue?vue&type=template&id=1c903c8f&scoped=true&"
import script from "./UploadCollateralModal.vue?vue&type=script&lang=js&"
export * from "./UploadCollateralModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadCollateralModal.vue?vue&type=style&index=0&id=1c903c8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c903c8f",
  null
  
)

export default component.exports